import React, { useState } from 'react';
import QuestionCreateForm from './question_create_form';

const Index = ({ questions }) => {
  const [question, setQuestion] = useState(questions[0]);
  return (
    <>
      <div className="p-5">
        <h2>アンケート一覧</h2>
        <ul>
          {questions.map((question) => {
            return (
              <li key={question.id}>
                <a href={`/questions/${question.url_key}`}>{question.title}</a>
              </li>
            );
          })}
        </ul>
        <h2 className="mt-4">アンケート確認</h2>
        <select
          name="question"
          id="question"
          value={question ? question.id : ''}
          onChange={(e) => {
            const selectedId = Number(e.target.value);
            const found = questions.find((q) => q.id === selectedId);
            setQuestion(found || null);
          }}
        >
          {questions.map((q) => (
            <option key={q.id} value={q.id}>
              {q.title}
            </option>
          ))}
        </select>
        <div className="mt-3">
          <a href={`/admin/questions/${question.id}`}>結果を確認</a>
        </div>

        <h2 className="mt-4">アンケート作成</h2>
        <QuestionCreateForm />
      </div>
    </>
  );
};

export default Index;
